<ng-container *ngIf="loadingPaging">
  <div class="container-loading">
    <div class="lds-ellipsis">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  </div>
</ng-container>